import React from 'react';
import { Box, Typography } from '@mui/material';
import { IAttachmentFile } from '../../../../interfaces/corporateEvent';
import { DATE_FORMAT_SLASH, fDate } from '../../../../utils/formatTime';
import { checkIfImage, getFileIcon } from '../../../../utils/commonUtils';
import './attachmentCard.scss';

interface IAttachmentCardProps {
  attachment: IAttachmentFile;
}

const AttachmentCard = ({ attachment }: IAttachmentCardProps) => {
  const isImage = checkIfImage(attachment);

  return (
    <Box className="attachmentCard" onClick={() => window.open(attachment.fileUrl, '_blank')}>
      {isImage ? (
        <img width={32} height={32} src={attachment.fileUrl} className="attachmentImage" alt="attachment" />
      ) : (
        getFileIcon(attachment)({})
      )}
      <Box className="attachmentNameContainer">
        <Typography className="attachmentName">{attachment.fileName}</Typography>
        <Typography className="attachmentDate">
          {fDate(attachment.createdAt as string, DATE_FORMAT_SLASH)}
        </Typography>
      </Box>
    </Box>
  );
};

export default AttachmentCard;
